import moment from 'moment';
import {cloneDeep} from 'lodash-es';
import template from "./timeline.html";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';

const NS = 'Timeline'; // jshint ignore:line

export default function Timeline(  // as timeline
  $filter, $window, $document, $interval, $timeout, $rootScope, unregister
) {
  "ngInject";

  return {
    bindToController: true,
    controller: function () { },
    controllerAs: 'vm',
    restrict: 'E',
    template,
    link,
    scope: {
      date: '<',
      time: '=',
      startTime: '=',
      endTime: '=',
      schedule: '=',
      services: '=',
      scheduleBookingIntervals: '='
    }
  };


  function link(scope) {
    var vm = scope.vm;
    var timelineBar = $window.document.getElementById('timeline-bar');
    var timelineBarEL = angular.element(timelineBar);
    var timeMask = timelineBar.getElementsByClassName('time-mask')[0];
    var timeScroll = timelineBar.getElementsByClassName('time-scroll')[0];
    var timeScrollEl = angular.element(timeScroll);
    var timeDrag = timelineBar.getElementsByClassName('time-drag')[0];
    var timeDragEl = angular.element(timeDrag);
    var cursor = $window.document.getElementById('timeline-cursor');
    var cursorEL = angular.element(cursor);
    var startDragTarget;
    var mousePostion;
    var lastPosition;
    var dragging = false;
    var updateTimeTimeout;
    const timeZoneId = AdminService.getVenueTimezoneId();
    //-- define public properties
    vm.minuteLength = 2; // px for every min
    vm.cursorDragging = false;
    vm.isCurruntTime = false;
    vm.isToday = false;

    //-- define public methods
    vm.endClick = endClick;
    vm.cursorStartDrag = cursorStartDrag;
    vm.cursorEndDrag = cursorEndDrag;
    vm.setToNow = setToNow;
    vm.timeUpdated = timeUpdated;
    vm.getMinOfDay = getMinOfDay;

    //-- listen
    var listeners = [];
    listeners.push(scope.$watch('vm.startTime', calulateTimeline));
    listeners.push(scope.$watch('vm.endTime', calulateTimeline));
    listeners.push(scope.$watch('vm.time', checkTimeUpdate));
    listeners.push(scope.$watch('scheduleBookingIntervals', updateTimeLine));
    listeners.push(scope.$on('$destroy', destory));
    $window.addEventListener('resize', updateSizes);

    timeDragEl.on('touchstart', startDrag);
    timeDragEl.on('mousedown', startDrag);
    timeDragEl.on('mouseup', endClick);
    timeDragEl.on('touchend', endClick);

    cursorEL.on('mousedown', cursorStartDrag);
    cursorEL.on('mouseup', cursorEndDrag);
    cursorEL.on('touchstart', cursorStartDrag);
    cursorEL.on('touchend', cursorEndDrag);

    //-- init
    getGeneralSettings();
    updateSizes();

    function destory() {
      unregister(listeners);

      $window.removeEventListener('resize', updateSizes);

      timelineBar = null;
      timelineBarEL = null;
      timeMask = null;
      timeScroll = null;
      timeScrollEl = null;
      timeDrag = null;
      timeDragEl = null;
      cursor = null;
      cursorEL = null;
      startDragTarget = null;
    }

    function checkTimeUpdate(n, o) {
      if (n && n !== o) {
        timeUpdated();
      }
    }

    function updateSizes() {
      var width = (timelineBarEL[0].clientWidth - (timelineBar.offsetLeft + timeMask.offsetLeft));
      timeScroll.style.width = width + 'px';
    }

    function getGeneralSettings() {
      GeneralSettingsService.get().then(function (settings) {
        vm.generalSettings = settings;
      });
    }

    /**
     * Gets the earliest start time in a list of services
     */
    function getEarliestStartTime(services) {
      return moment.min(services.map(s => moment(s.startTime))).toDate();
    }

    /**
     * Gets the latest end time in a list of services
     */
    function getLatestEndTime(services) {
      return moment.max(services.map(s => moment(s.endTime))).toDate();
    }

    function updateTimeLine() {
      if (vm.schedule) {
        var sericesStart = $filter('orderBy')(vm.schedule.services, 'startTime');
        var sericesEnd = $filter('orderBy')(vm.schedule.services, 'endTime');
        var openTime = sericesStart[0].startTime;
        var closeTime = sericesEnd[sericesEnd.length - 1].endTime;
        if (vm.services && vm.services.length) {
          openTime = getEarliestStartTime(vm.services);
          closeTime = getLatestEndTime(vm.services);
        }

        var bookingByEndDate = $filter('orderBy')(vm.bookings, 'bookingEnd', true);
        if (bookingByEndDate) {
          var lastBooking = bookingByEndDate[0];
          if (lastBooking && lastBooking.bookingEnd.getTime() > closeTime.getTime()) {
            closeTime = lastBooking.bookingEnd;
          }

        }
        vm.startHour = openTime.getHours();
        vm.totalHours = DateUtilsService.hoursBetweenDates(openTime, closeTime) + 3;
        vm.endHour = vm.startHour + vm.totalHours;
        vm.startMinute = (vm.startHour * 60);
        vm.endMinute = (vm.totalHours * 60);
      }
    }

    function cursorStartDrag(evt) {
      vm.cursorDragging = true;
      vm.isCurruntTime = false;
      if (updateTimeTimeout) {
        $interval.cancel(updateTimeTimeout);
      }
      var pageX = evt.pageX;
      if (!pageX && evt.touches && evt.touches[0]) {
        pageX = evt.touches[0].pageX;
      }
      var pageY = evt.pageY;
      if (!pageY && evt.touches && evt.touches[0]) {
        pageY = evt.touches[0].pageY;
      }
      lastPosition = {
        x: pageX,
        y: pageY,
        evt: evt
      };
      $document.off('touchmove', updateCursorPositionDrag);
      $document.on('touchmove', updateCursorPositionDrag);
      $document.off('touchend', updateCursorPositionDrag);
      $document.on('touchend', cursorEndDrag);
      $document.off('mousemove', updateCursorPositionDrag);
      $document.on('mousemove', updateCursorPositionDrag);
      $document.on('mouseup', cursorEndDrag);
    }

    function cursorEndDrag() {
      $window.document.body.style.cursor = 'default';
      $document.off('touchmove', updateCursorPositionDrag);
      $document.off('touchend', updateCursorPositionDrag);
      $document.off('mousemove', updateCursorPositionDrag);
      var minutesOnTimeLine = Math.round(vm.cursorPosition / vm.minuteLength);
      setTime(minutesOnTimeLine);
      setTimeout(function () {
        vm.cursorDragging = false;
      }, 300);
    }

    function updateCursorPositionDrag(evt) {
      scope.$evalAsync(function () {
        $window.document.body.style.cursor = 'move';
        var pageX = evt.pageX;
        if (!pageX && evt.touches && evt.touches[0]) {
          pageX = evt.touches[0].pageX;
        }
        var pageY = evt.pageY;
        if (!pageY && evt.touches && evt.touches[0]) {
          pageY = evt.touches[0].pageY;
        }
        mousePostion = {
          x: pageX,
          y: pageY,
          evt: evt
        };
        var movementX = mousePostion.x - lastPosition.x;
        lastPosition = mousePostion;
        vm.cursorPosition += movementX;
        if (vm.cursorPosition < 0) {
          vm.cursorPosition = 0;
        }
        var minutesOnTimeLine = Math.round((vm.cursorPosition + 4) / vm.minuteLength);
        var newTime = cloneDeep(vm.startTime.toDate());
        newTime.setMinutes(0);
        newTime.setSeconds(0);
        newTime.setMinutes(newTime.getMinutes() + minutesOnTimeLine);
        vm.draggingTime = newTime;
        if ((vm.cursorPosition - 20) < timeScroll.scrollLeft) {
          timeScroll.scrollLeft -= 3;
        }
        if ((vm.cursorPosition + 280) > (timeScroll.offsetWidth + timeScroll.scrollLeft)) {
          timeScroll.scrollLeft += 3;
        }
      });
    }

    function startDrag(evt) {
      if (updateTimeTimeout) {
        $interval.cancel(updateTimeTimeout);
      }
      startDragTarget = angular.element(evt.target);

      var pageX = evt.pageX;
      if (!pageX && evt.touches && evt.touches[0]) {
        pageX = evt.touches[0].pageX;
      }

      var pageY = evt.pageY;
      if (!pageY && evt.touches && evt.touches[0]) {
        pageY = evt.touches[0].pageY;
      }

      lastPosition = {
        x: pageX,
        y: pageY,
        evt: evt
      };

      removeDragListeners(startDragTarget);
      addDragListeners(startDragTarget);
    }

    function endClick(evt) {
      if (dragging) {
        endDrag(evt);
        setTimeout(function () {
          dragging = false;
        }, 200);
      } else {
        scope.$evalAsync(function () {
          selectTime(evt);
        });
      }
    }

    function selectTime(evt) {
      var position;
      if (evt.offsetX == null)
      {
        var rect2 = evt.target.getBoundingClientRect();
        var bodyRect2 = document.body.getBoundingClientRect();
        var x2 = evt.originalEvent.changedTouches[0].pageX - (rect2.left - bodyRect2.left);

        position = x2;

      }
      else
      {

        position = evt.offsetX;
      }


      if (!evt.offsetX && lastPosition && lastPosition.evt.touches && lastPosition.evt.touches.length) {
        var rect = lastPosition.evt.target.getBoundingClientRect();
        var x = lastPosition.evt.targetTouches[0].pageX - rect.left;
        position = x;
      }
      var minutesOnTimeLine = Math.round(position / vm.minuteLength);
      setTime(minutesOnTimeLine);
    }

    function setTime(minutesOnTimeLine) {
      var newTime = cloneDeep(vm.startTime.toDate());
      newTime.setMinutes(0);
      newTime.setSeconds(0);
      newTime.setMinutes(newTime.getMinutes() + minutesOnTimeLine);
      vm.time = newTime;
      checkIsCurrentTime();
      updateCursorPosition();
    }

    function endDrag(evt) {
      $window.document.body.style.cursor = 'default';
      removeDragListeners(startDragTarget);
      cursorEndDrag(evt);
      checkIsCurrentTime();
    }

    function addDragListeners(target) {
      target.on('mouseleave', endDrag);
      target.on('mousemove', updatePostion);
      target.on('touchmove', updatePostionTouch);
    }

    function removeDragListeners(target) {
      target.off('mouseleave', endDrag);
      target.off('mousemove', updatePostion);
      target.off('touchmove', updatePostionTouch);
    }

    function updatePostionTouch() {
      dragging = true;
    }

    function updatePostion(evt) {
      scope.$evalAsync(function () {

        let pageX = evt.pageX;
        if (!pageX && evt.touches && evt.touches[0]) {
          pageX = evt.touches[0].pageX;
        }
        let pageY = evt.pageY;
        if (!pageY && evt.touches && evt.touches[0]) {
          pageY = evt.touches[0].pageY;
        }
        mousePostion = {
          x: pageX,
          y: pageY,
          evt: evt
        };
        const movementX = mousePostion.x - lastPosition.x;

        /**
         * Allow for imperfect clicks.
         * If 5 pixel or less movement ignore drag and treat as a click.
         */
        if (Math.abs(movementX) <= 5) {
          return;
        }
        lastPosition = mousePostion;
        timeScroll.scrollLeft -= movementX;
        dragging = true;
        $window.document.body.style.cursor = 'move'; // Nb: can have performance hit
      });
    }

    function calulateTimeline() {
      if (vm.time && vm.startTime && vm.endTime) {  // zs test
        var startDate = vm.startTime.toDate();
        vm.isToday = DateUtilsService.isDateToday(startDate, timeZoneId);

        var intervalMarkers = [];
        var startHour = vm.startTime.hours();
        vm.totalHours = DateUtilsService.hoursBetweenDates(startDate, vm.endTime.toDate()) + 2;

        var endHour = startHour + vm.totalHours;
        var min = startHour * 60;
        var totalMins = endHour * 60;
        var clearDate = DateUtilsService.getClearDate(startDate, timeZoneId);
        var intervalDate = DateUtilsService.getClearDate(startDate, timeZoneId);
        intervalDate.setMinutes(min);

        // loop over the times and create an interval every 15 mins
        for (min; min <= totalMins; min += 15) {
          var minOfDay = DateUtilsService.minsBetweenDates(clearDate, intervalDate);
          var intervalTime = cloneDeep(intervalDate);
          var position = (minOfDay - (startHour * 60)) * vm.minuteLength;
          intervalMarkers.push({
            time: intervalTime,
            label: (intervalTime.getMinutes() === 0) ? $filter('date')(intervalTime, 'ha') : '',
            position: position
          });
          intervalDate.setMinutes(intervalDate.getMinutes() + 15);
        }

        updateCursorPosition();
        vm.intervalMarkers = intervalMarkers;
        $timeout(checkMarkerOffScreen, 300);
        checkIsCurrentTime();
        updateSizes();
      }
    }

    function setToNow() {
      updateTime();
      checkIsCurrentTime();
      checkMarkerOffScreen();
      $rootScope.$broadcast('select-service', -1); //Select service All by index 0
    }

    function checkIsCurrentTime() {
      var diffSeceonds = (Math.abs(vm.time - DateUtilsService.getVenueTime(timeZoneId)) / 1000);
      vm.isCurruntTime = (diffSeceonds < 60);
      if (updateTimeTimeout) {
        $interval.cancel(updateTimeTimeout);
      }
      if (vm.isCurruntTime) {
        updateTimeTimeout = $interval(function () {
          updateTime();
        }, 1000 * 20);
      }
    }

    function updateTime() {
      var newTime = DateUtilsService.getVenueTime(timeZoneId);
      newTime.setSeconds(0);
      newTime.setMilliseconds(0);
      if (newTime.getTime() > vm.endTime.toDate().getTime()) {
        newTime = vm.endTime.toDate();
      }
      vm.time = newTime;
      updateCursorPosition();
    }

    function timeUpdated() {
      updateCursorPosition();
      checkIsCurrentTime();
    }

    function updateCursorPosition() {
      if (vm.time) {
        var startMin = (vm.startTime.hours() * 60); //+ vm.startTime.minutes();
        vm.cursorPosition = (((vm.time.getHours() * 60) + vm.time.getMinutes()) - startMin) * vm.minuteLength;
      }
    }

    function checkMarkerOffScreen() {
      if (timeScroll && vm.cursorPosition > (timeScroll.offsetWidth + timeScroll.scrollLeft)) {
        timeScroll.scrollLeft = vm.cursorPosition - 100;
      }
    }

    function getMinOfDay(time) {
      return DateUtilsService.getMinOfDay(vm.date, time);
    }
  }

}
